// @ts-ignore
import React from "react";

import GlobalFooter from "@/patterns/global-footer/src/index";
import GlobalNavigation from "@/patterns/global-nav/src/index";

import { MainSection } from "./sections/main";

export const FourOhFourPageTemplate = () => {
    return (
        <div>
            <div>
                <GlobalNavigation
                    showTryNow={true}
                    color={"#f4f5f7"}
                    productKey="404"
                />
            </div>
            <div>
                <div>
                    <MainSection />
                </div>
            </div>
            <GlobalFooter />
        </div>
    );
};
